import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import CancelIcon from '@mui/icons-material/Cancel';
import { Controller, useFormContext } from 'react-hook-form';

function FormSelectRoleId({
  name = 'role_ids',
  label = 'Roles',
  options = [],
  roleLabelById = {},
}) {
  const {
    control,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const selectLabelId = `${name}-multiselect-label`;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field }) => {
        const value = Array.isArray(field.value) ? field.value : [];

        const handleDelete = (idToDelete) => {
          field.onChange(value.filter((id) => id !== idToDelete));
        };

        return (
          <FormControl fullWidth size="small" variant="outlined" error={!!errors[name]}>
            <InputLabel id={selectLabelId}>{label}</InputLabel>

            <Select
              labelId={selectLabelId}
              multiple
              value={value}
              label={label}
              name={field.name}
              onBlur={field.onBlur}
              inputRef={field.ref}
              onFocus={() => clearErrors(name)}
              onChange={(e) => {
                const val = e.target.value;
                field.onChange(typeof val === 'string' ? val.split(',') : val);
              }}
              renderValue={(selected) => {
                const ids = Array.isArray(selected) ? selected : [];
                return (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {ids.map((id) => (
                      <Chip
                        key={id}
                        size="small"
                        label={roleLabelById?.[id] ?? id}
                        onMouseDown={(e) => e.stopPropagation()}
                        onDelete={() => handleDelete(id)}
                        deleteIcon={<CancelIcon onMouseDown={(e) => e.stopPropagation()} />}
                      />
                    ))}
                  </Box>
                );
              }}
              MenuProps={{
                autoFocus: false,
                PaperProps: { sx: { maxHeight: 320 } },
              }}
            >
              {options.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  <Checkbox
                    checked={value.includes(opt.value)}
                    size="small"
                    sx={{ mr: 1, py: 0 }}
                  />
                  <ListItemText primary={opt.label} />
                </MenuItem>
              ))}
            </Select>

            <FormHelperText>{errors[name]?.message ?? ''}</FormHelperText>
          </FormControl>
        );
      }}
    />
  );
}

FormSelectRoleId.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  roleLabelById: PropTypes.object,
};

export default FormSelectRoleId;
